import React from "react";
import PropTypes from "prop-types";
import Card from "components/Card";

export default class PlaceholderCard extends React.Component {
  static propTypes = {
    school: PropTypes.object.isRequired,
    objectName: PropTypes.string.isRequired
  }
  render() {
    const schoolName = this.props.school.get("name");
    return (
      <Card>
        <Card.Body>
          <div className="message-list__placeholder">
            {`${schoolName} has no ${this.props.objectName} to display.`}
          </div>
        </Card.Body>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/teachers/PlaceholderCard.js